
import React from 'react';

import { translate } from '../../../base/i18n';
import { Icon, IconLiveStream, IconRecording } from '../../../base/icons';
import { CircularLabel } from '../../../base/label';
import { MHRecordingConstants } from '../../../base/lib-meet-hour';
import { connect } from '../../../base/redux';
import { setRecordingMode } from '../../actions.any';
import AbstractRecordingLabel, {
    _mapStateToProps
} from '../AbstractRecordingLabel';

/**
 * Implements a React {@link Component} which displays the current state of
 * conference recording.
 *
 * @augments {Component}
 */
class RecordingLabel extends AbstractRecordingLabel {
    /**
     * Renders the platform specific label component.
     *
     * @inheritdoc
     */
    _renderLabel() {
        if (this.props._status !== MHRecordingConstants.status.ON) {
            // Since there are no expanded labels on web, we only render this
            // label when the recording status is ON.
            return null;
        }

        if (this._getLabelKey() === 'recording.recLive') {
            return (
                <div className = 'recording-label label_buttons'><Icon src = { IconLiveStream } /><span>{this.props.t(this._getLabelKey())}</span></div>
            );
        }

        if (this._getLabelKey() === 'recording.live') {
            setRecordingMode(MHRecordingConstants.mode.STREAM);
        } else if (this._getLabelKey() === 'recording.rec') {
            setRecordingMode(MHRecordingConstants.mode.FILE);
        } else if (this._getLabelKey() === 'recording.recLive') {
            setRecordingMode(MHRecordingConstants.mode.FILE);
        } else {
            setRecordingMode(undefined);
        }


        return (

            <CircularLabel
                className = { 'recording-label label_buttons' }
                header = { true }
                icon = { this._getLabelKey() === 'recording.live' ? IconLiveStream : IconRecording }
                label = { this.props.t(this._getLabelKey()) }
                status = { this.props._status } />
        );
    }

    _getLabelKey: () => ?string;
}

export default translate(connect(_mapStateToProps)(RecordingLabel));
